<div echarts [options]="option" class="demo-chart"></div>
